// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"96":"5279368c","105":"f0a9c992","163":"52ad305a","341":"b5f1f4ca","377":"01583788","387":"8e827327","816":"9dca78ef"}[chunkId] + ".js";
};